var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{ref:"link",staticClass:"link",attrs:{"href":_vm.apiUrl,"target":"blank"}},[_vm._v("Go api document page ..")])])
}
var staticRenderFns = []

export { render, staticRenderFns }